import React from 'react';
import PropTypes from 'prop-types';

import Carousel from '@prisjakt/ui-carousel';
import MatchMedia from '../match-media';
import Modal from '../modal';

import * as S from './styles';

class Lightbox extends React.Component {
  componentWillUnmount() {
    this.props.close();
  }

  render() {
    const { items, position, thumbnails } = this.props;

    if (!items || !thumbnails) {
      return null;
    }

    return (
      <Modal
        id="lightboxModal"
        isOpen={this.props.isOpen}
        onRequestClose={this.props.close}
      >
        <MatchMedia
          debounce={150}
          serverSideRender={{ height: '450px', thumbs: null }}
          matches={[
            {
              mediaQuery: '(max-width: 640px)',
              values: { height: '300px', thumbs: null },
            },
            {
              mediaQuery: '(min-width: 640px)',
              values: { height: '450px', thumbs: thumbnails },
            },
          ]}
        >
          {({ height, thumbs }) => (
            <S.Lightbox>
              <Carousel
                focus
                height={height}
                position={position}
                onChange={this.props.onChange}
                thumbnails={thumbs}
                clickForNext
              >
                {items.map(item => item)}
              </Carousel>
            </S.Lightbox>
          )}
        </MatchMedia>
      </Modal>
    );
  }
}

const { arrayOf, node, number, func, bool } = PropTypes;

Lightbox.propTypes = {
  items: arrayOf(node),
  thumbnails: arrayOf(node),
  position: number,
  close: func.isRequired,
  onChange: func,
  isOpen: bool,
};

Lightbox.defaultProps = {
  items: null,
  thumbnails: null,
  position: 0,
  onChange: () => {},
  isOpen: false,
};

export default Lightbox;
